import { render, staticRenderFns } from "./BrowseTotalItemsResult.vue?vue&type=template&id=1d8f1a28&scoped=true"
import script from "./BrowseTotalItemsResult.vue?vue&type=script&lang=ts"
export * from "./BrowseTotalItemsResult.vue?vue&type=script&lang=ts"
import style0 from "./BrowseTotalItemsResult.vue?vue&type=style&index=0&id=1d8f1a28&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8f1a28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d8f1a28')) {
      api.createRecord('1d8f1a28', component.options)
    } else {
      api.reload('1d8f1a28', component.options)
    }
    module.hot.accept("./BrowseTotalItemsResult.vue?vue&type=template&id=1d8f1a28&scoped=true", function () {
      api.rerender('1d8f1a28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/BrowseTotalItemsResult.vue"
export default component.exports